import { Roles } from '@/core/constants/roleConstants';
import { BasePolicy } from '../BasePolicy';

export class UpcomingArrivalsPolicy extends BasePolicy {
  static canView() {
    const roles = [
      Roles.SELLER,
      Roles.MANAGER,
      Roles.SUB_MANAGER,
      Roles.REGIONAL_MANAGER,
      Roles.SUB_DIRECTOR,
      Roles.DIRECTOR,
      Roles.DIRECTOR_NON_COMMERCIAL,
      Roles.SUB_DIRECTOR_NON_COMMERCIAL_WHOLESALER,
      Roles.SUB_DIRECTOR_NON_COMMERCIAL_RETAIL,
      Roles.SUPER_USER,
    ];

    return this.hasAnyRole(roles);
  }
}
